/**
 * Extract the extension from a filename.
 */
export function getExt(filename: string) {
  return /(?:[.]([^.]+))?$/.exec(filename)?.pop();
}
